<div class="splash-screen-center">
  <div class="splash-screen">
    <img [src]="image" class="splash-screen-image">
    <div class="splash-screen-progress-bar splash-screen-progress-bar-center">
      <mat-progress-bar [mode]="mode" [color]="color"></mat-progress-bar>
    </div>
  </div>
</div>
